<template lang="pug">
.input-change-order(:data-vertical='isVertical')
  .input-change-order__selected
    .input-change-order__selected__text
      template(v-for="(val, i) in selectedValue")
        span.arrow(v-if="i > 0") {{ isVertical ? '↓' : '→' }}
        span.value {{ val }}
    button-base.input-change-order__selected__reset(@click='resetValues')
      fa-icon(icon='redo')
  .input-change-order__input
    template(v-for='(item, index) in items')
      input.input-change-order__input__checkbox(
        type='checkbox',
        :id='getInputId(index)',
        :value='item.value',
        :disabled='isDisabled(item.value)',
        v-model='inputValue'
      )
      label-base.input-change-order__input__label.text-large(
        :for='getInputId(index)',
        :data-selected='dataSelected(item.value)'
      ) {{ item.value }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import { InputItem } from '@/models/inputItem'

/**
 * 並び替え
 */
@Component({
  components: {
    ButtonBase,
    LabelBase,
  },
})
export default class InputChangeOrder extends Vue {
  // 選択肢情報
  @Prop()
  items!: InputItem[]

  // 選択値
  @Prop()
  value!: string[]

  // 選択解除可能フラグ
  @Prop({ default: false })
  canDeselected?: boolean

  // 縦書きフラグ
  @Prop({ default: false })
  isVertical?: boolean

  // コンポーネント単位のユニークID取得
  private readonly UID = this.$uuid.v4()

  // inputタグの個別ID
  private getInputId(index: number): string {
    return `id${this.UID}_${index}`
  }

  // 選択状態に応じてカスタムデータ属性を付与
  private dataSelected(value: string): boolean {
    return this.value.includes(value)
  }

  // 選択解除不可時、一度選択した値はチェックボックスdisabled
  private isDisabled(value: string): boolean {
    return !this.canDeselected && this.dataSelected(value)
  }

  // 表示用のテキスト生成
  private get selectedValue(): string[] {
    // 未選択時は空文字
    if (this.value.length == 0) {
      return []
    }
    // 選択値を結合して返す
    return this.value.map((val) => {
      return (
        this.items.find((item) => {
          return item.value === val
        })?.value || ''
      )
    })
  }

  // 選択値のゲッターセッター
  get inputValue(): string[] {
    return this.value
  }
  set inputValue(value: string[]) {
    this.$emit('input', value)
  }

  /**
   * リセットボタン押下時イベント
   */
  private resetValues() {
    this.$emit('input', [])
  }
}
</script>

<style lang="stylus" scoped>
.input-change-order
  &__selected
    display flex
    flex-wrap nowrap
    flex-direction row
    align-items center
    margin 0 0 20px 0

    &__text
      min-width 15rem
      min-height var(--input-height-default)
      padding 5px
      border-radius 4px
      border 1px solid var(--color-default__border)
      overflow-wrap anywhere
      margin 0 5px 0 0

    &__reset
      width var(--input-height-default)
      height var(--input-height-default)
      padding 10px
      background-color var(--color-study-input-order-button__background)
      color var(--color-study-input-order-button__text)
      border-radius 10px

  &__input
    display flex
    flex-wrap wrap
    align-content flex-start

    &__checkbox
      display none

    &__label
      margin 5px 5px 5px 0
      padding 5px 20px 5px 20px
      border 1px solid var(--color-default__border)
      border-radius 10px
      background-color var(--color-default__background)

      &[data-selected='true']
        background-color var(--color-default__border)
  &[data-vertical='true'] &__selected
    margin 0 0 0 20px

    &__text
      min-width var(--input-height-default)
      min-height 15rem
      margin 0 0 5px 0

  &[data-vertical='true'] &__input
    &__label
      margin 0 5px 5px 5px
      padding 20px 5px 20px 5px

&[data-vertical='true']
  .input-change-order
    &__selected
      &__text
        writing-mode horizontal-tb
        display flex
        flex-direction column
        align-items center
        justify-content flex-start
</style>
